export default __webpack_public_path__ + "static/media/bg-popular3.1521261a.jpg";